import { Tooltip } from '@app/components/various/Tooltip';
import { getIsInvoiceStandard } from '@app/logic/invoices';
import { useResizeObserver, useScreenResize } from '@app/utils/hooks';
import { useIsOverflowing } from '@app/utils/hooks/useIsOverflowing';
import { Invoice } from '@typings';
import cx from 'classnames';
import React from 'react';

interface Props {
  invoice: Invoice.AnyInvoice;
}

export const InvoicesListAddressCell = ({ invoice }: Props) => {
  const parentRef = React.useRef<HTMLDivElement>(null);
  const ref = React.useRef<HTMLDivElement>(null);
  const isOverflowing = useIsOverflowing(ref);

  const [initialWidth, setInitialWidth] = React.useState<number>(0);
  const [hasAvailableSpace, setHasAvailableSpace] = React.useState<boolean>(true);

  React.useEffect(() => {
    const parentWidth = parentRef.current?.offsetWidth ?? 0;
    const width = ref.current?.offsetWidth ?? 0;

    setInitialWidth(width);
    setHasAvailableSpace(parentWidth > width + 1);
  }, []);

  const updateHasAvailableSpace = React.useCallback(() => {
    const parentWidth = parentRef.current?.offsetWidth ?? 0;

    setHasAvailableSpace(parentWidth > initialWidth + 1);
  }, [initialWidth]);

  useScreenResize(updateHasAvailableSpace);
  useResizeObserver(parentRef, updateHasAvailableSpace);

  if (!getIsInvoiceStandard(invoice)) {
    return null;
  }

  return (
    <div ref={parentRef} className="z-interactiveTableItem w-full">
      <Tooltip content={isOverflowing && invoice.address}>
        <div ref={ref} className={cx('z-interactiveTableItem w-fit truncate', { 'max-w-60': !hasAvailableSpace })} data-sentry-mask>
          {invoice.address}
        </div>
      </Tooltip>
    </div>
  );
};
